import React from 'react'
import PropTypes from 'prop-types'
import { formatPrice } from 'common/helpers'

import CrossedPrice from 'components/ui/CrossedPrice/CrossedPrice'
import PriceWithDiscount from 'components/ui/PriceWithDiscount/PriceWithDiscount'

import s from './OldAndNewPrices.scss'


const OldAndNewPrices = ({ className, newPrice, oldPrice, isCents, dataTestId = 'oldAndNewProductPrices' }) => (
  <span className={className} data-testid={dataTestId}>
    <PriceWithDiscount className={s.newPrice} price={formatPrice(newPrice, isCents)} />
    <CrossedPrice className={s.oldPrice} price={formatPrice(oldPrice, isCents)} />
  </span>
)

OldAndNewPrices.propTypes = {
  newPrice: PropTypes.number,
  oldPrice: PropTypes.number,
  isCents: PropTypes.bool,
  dataTestId: PropTypes.string,
}

OldAndNewPrices.defaultProps = {
  isCents: false,
}


export default OldAndNewPrices
